<template>
    <b-container class="TunnelPopup my-4">
        <div>
            <b-modal id="modal-1" ref="modal-1" size="xl" no-close-on-backdrop no-close-on-esc hide-header hide-footer centered modal-class="bg-transparent" body-class="p-0 d-flex flex-wrap bg-transparent my-3 my-sm-0" content-class="bg-transparent border-0" v-if="tunnel" visible>
                <div class="col-12 col-lg-4 bg-rose rounded-10 d-flex flex-column justify-content-center">
                    <div class="pt-2 pt-lg-5">

                        <!-- Matiere -->
                        <div v-if="step === 'isShowingMaterials'">
                            <div>
                                <img class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/picto-editeur.png" width="110px" height="75px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseMaterial /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionMaterial /></span>
                            </div>
                        </div>

                        <!-- Metal -->
                        <div v-if="selectedMaterial && selectedMaterial.category_id == 1 && step === 'isShowingMatters'">
                            <div>
                                <img class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/metal.png" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseMetal /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionMetal /></span>
                            </div>
                        </div>

                        <!-- Bois -->
                        <div v-if="selectedMaterial && selectedMaterial.category_id == 2 && step === 'isShowingMatters'">
                            <div>
                                <img class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/bois.png" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseWood /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionWood /></span>
                            </div>
                        </div>

                        <!-- Nuance -->
                        <div v-if="step === 'isShowingShades'">
                            <div>
                                <img v-if="selectedMaterial.category_id == 1" class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/metal.png" height="110px">
                                <img v-else class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/bois.png" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseMatter /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionMatter /></span>
                            </div>
                        </div>

                        <!-- Epaisseur -->
                        <div v-if="step === 'isShowingThicknesses'">
                            <div>
                                <img class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/thicknesses.png" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseThickness /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionThickness /></span>
                            </div>
                        </div>

                        <!-- Forme -->
                        <div v-if="step === 'isShowingShapes'">
                            <div>
                                <img class="d-none d-xl-block mx-auto animated fadeInRight" src="@/assets/img/shapes.png" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseShape /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5"><t tunnelPopup.descriptionShape /></span>
                            </div>
                        </div>

                        <!-- Dimensions -->
                        <div v-if="step === 'isShowingDimensions'">
                            <div>
                                <img class="d-none d-lg-block mx-auto animated fadeInRight" src="@/assets/img/dimensions.svg" height="110px">
                                <span class="h1 font-weight-bold text-center text-white d-block mt-3 animated fadeInRight"><t tunnelPopup.chooseDimensions /></span>
                                <hr class="bg-white w-25 animated fadeInRight my-2" />
                                <span class="h4 text-white d-block text-center animated fadeInRight mb-4 mb-lg-5 px-4"><t tunnelPopup.descriptionDimensions /></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-11 col-lg-8 pl-2 pr-0 bg-white mx-auto my-0 my-lg-2 rounded-right-10">
                    <!-- Materiaux -->
                    <div id="materials" class="h-100 d-flex flex-column pb-2 mr-2" v-if="step === 'isShowingMaterials'">
                        <b-button variant="link" v-for="material in categories" :key="material.category_id" class="one-choice px-0 w-100 rounded-10 text-decoration-none mt-2 border-0 py-0 texture" @click="step = 'isShowingMatters'; selectedMaterial = material">
                            <div class="materials-img rounded-10">
                                <img class="position-absolute animated" :src="require('@/assets/img/' + material.name['fr'].toLowerCase() + '.jpg')">
                                <span class="h1 text-white text-center d-flex mb-0 py-4 h-100 align-items-center justify-content-center">{{material.name[language]}}</span>
                            </div>
                        </b-button>
                    </div>

                    <!-- Matieres -->
                    <div id="matters" class="h-100 d-flex flex-column pb-2 mr-2" v-if="step === 'isShowingMatters'">
                        <b-button class="position-absolute return p-0 border-0 animated fadeIn" variant="link" @click="step = 'isShowingMaterials'">
                            <svg data-v-4f717519="" viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="arrow left circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-left-circle-fill rounded float-right b-icon bi animated fadeIn" style="font-size: 200%;">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
                            </svg>
                        </b-button>
                        <b-button variant="link" v-for="matter in mattersForProduct" :key="matter.matter_id"  class="one-choice px-0 w-100 rounded-10 text-decoration-none mt-2 border-0 animated fadeIn texture" :style="{ backgroundImage: 'url(/modules/johnsteel_editeur/views/img/textures/' + getUrlName(matter.name['fr']) + '.jpg' + ')' }" @click="step = 'isShowingShades'; selectedMatter = matter">
                            <span  class="h1 text-white text-center d-block mb-0">{{matter.name[language]}}</span>
                        </b-button>
                    </div>

                    <!-- Nuances -->
                    <div id="shades" class="h-100 d-flex pb-2 flex-wrap" v-if="step === 'isShowingShades'">
                        <b-button class="position-absolute return p-0 border-0 animated fadeIn" variant="link" @click="step = 'isShowingMatters'">
                            <svg data-v-4f717519="" viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="arrow left circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-left-circle-fill rounded float-right b-icon bi" style="font-size: 200%;">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
                            </svg>                        
                        </b-button>
                        <div class="col-12 col-sm-6 col-xl-4 pl-0 pr-2 mt-2 animated fadeIn" v-for="shade in shadesForProduct" :key="shade.message">
                            <b-button variant="link"  class="px-0 py-0 rounded-10 text-decoration-none w-100 h-100 d-flex align-items-center justify-content-center border-0 texture" :style="{ backgroundImage: 'url(/modules/johnsteel_editeur/views/img/textures/' + shade.psid + '-300.jpg' + ')' }" @click="step = 'isShowingThicknesses'; selectedProduct = shade.psid">
                                <span class="h5 text-white text-center d-flex align-items-center mb-0 p-4 py-lg-0 font-weight-bold">{{ shade.name[language] }}</span>
                            </b-button>
                        </div>
                    </div>

                    <!-- Epaisseur -->
                    <div id="thicknesses" class="h-100 d-flex pb-2 flex-wrap" v-if="step === 'isShowingThicknesses'">
                        <b-button class="position-absolute return p-0 border-0 animated fadeIn" variant="link" @click="step = 'isShowingShades'">
                            <svg data-v-4f717519="" viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="arrow left circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-left-circle-fill rounded float-right b-icon bi" style="font-size: 200%;">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
                            </svg>
                        </b-button>
                        <div class="col-4 pl-0 pr-2" v-for="thickness in thicknessesForProduct" :key="thickness.message">
                            <b-button variant="link" class="thickness p-0 rounded-10 text-decoration-none mt-2 w-100 animated fadeIn texture"  @click="step = 'isShowingShapes'; selectedThickness = thickness.psid;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -5 221.26 165" class="mx-3 pt-4 pb-0" :class="selectedMaterial.name['fr']" height="130px">
                                    <defs>
                                        <pattern id="img1" patternUnits="userSpaceOnUse" width="300" height="200">
                                            <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                        </pattern>
                                    </defs>
                                    <rect fill="url(#img1)" filter="brightness(50%)" class="cls-1" y="58" width="100%" :height="Math.round(thickness.thickness)"/>
                                    <path fill="url(#img1)" filter="brightness(60%)" class="cls-1" :d="'M86.17,' + 2 * (Math.round(thickness.thickness) + 2) + '.85,6.45,' + (50 + Math.round(thickness.thickness)) + '.22a12,12,0,0,0,.14,21.3l80.2,40.28a53.12,53.12,0,0,0,47.67,0l80.2-40.28a12,12,0,0,0,.15-21.3L135.09,'+ 2 * (Math.round(thickness.thickness) + 2) + '.85a53.09,53.09,0,0,0-48.92,0Z'"/>
                                    <path fill="url(#img1)" class="cls-2" d="M86.17,6,6.45,47.34a12,12,0,0,0,.14,21.3l80.2,40.28a53.06,53.06,0,0,0,47.67,0l80.2-40.28a12,12,0,0,0,.15-21.3L135.09,6A53.09,53.09,0,0,0,86.17,6Z"/>

                                </svg>
                                <span class="bg-gris h6 text-white text-center d-block mb-0 pb-0 pb-sm-1 pt-1 pt-sm-2">{{ thickness.name }}</span>
                            </b-button>
                        </div>
                    </div>

                    <div id="shapes" class="h-100 d-flex pb-2 flex-wrap" v-if="step === 'isShowingShapes'">
                        <b-button class="position-absolute return p-0 border-0 animated fadeIn" variant="link" @click="step = 'isShowingThicknesses'" v-if="selectedProduct != null">
                            <svg data-v-4f717519="" viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="arrow left circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-left-circle-fill rounded float-right b-icon bi" style="font-size: 200%;">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
                            </svg>
                        </b-button>

                        <div class="d-flex flex-wrap overflow-hidden position-relative">
                            <div class="animate__animated d-flex flex-wrap animated" id="block-shape_1">
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'rectangle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + productPsid + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <rect fill="url(#img2)" x="25" y="0" width="150" height="100" rx="0" ry="0" />
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.rectangle /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'rectanglecutcircle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <rect fill="url(#img2)" x="25" y="0" width="150" height="100" rx="0" ry="0" />
                                                <circle class="fond" fill="#ffffff" cx="100" cy="50" r="35"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.rondelleCarree /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'rectanglecutrectangle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <rect fill="url(#img2)" x="25" y="0" width="150" height="100" rx="0" ry="0" />
                                                <rect class="fond" fill="#ffffff" x="80" y="20" width="40" height="60" rx="0" ry="0" />
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.cadre /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'circle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <circle fill="url(#img2)" cx="100" cy="50" r="50"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.circle /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'ring'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <circle fill="url(#img2)" cx="100" cy="50" r="50"/>
                                                <circle class="fond" fill="#ffffff" cx="100" cy="50" r="35"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.rondelle /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'rectanglerounded'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <circle fill="url(#img2)" cx="100" cy="50" r="50"/>
                                                <rect fill="url(#img2)" x="50" y="50" width="100" height="50" rx="0" ry="0" stroke-dasharray="0,100,200" />
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.rectangleArrondi /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'forme-l'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <polygon fill="url(#img2)" points="25 0, 110 0, 110 70, 175 70, 175 100, 25 100"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.l /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'notchrectangle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <polygon fill="url(#img2)" points="25 0, 80 0, 80 55, 120 55, 120 0, 175 0, 175 70, 175 100, 25 100"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.notchrectangle /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2 d-flex align-items-center justify-content-center flex-column cursor-pointer" @click="changeShapeStep(1, 2)">
                                    <span class="h1">...</span>
                                    <span class="d-block"><t tunnelPopup.otherShapes /></span>
                                </div>
                            </div>

                            <div class="d-none flex-wrap animated position-absolute" id="block-shape_2">
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'holesrectangle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>   
                                                <rect fill="url(#img2)" x="25" y="0" width="150" height="100" rx="0" ry="0"></rect>
                                                <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="55" cy="30" r="10"></circle>
                                                <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="55" cy="72" r="10"></circle>
                                                <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="145" cy="72" r="10"></circle>
                                                <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="145" cy="30" r="10"></circle>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.holesrectangle /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'trapeze'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <polygon fill="url(#img2)" points="80 0, 120 0, 150 100, 50 100"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.trapeze /></span>
                                    </b-button>
                                </div>
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'triangle'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <polygon fill="url(#img2)" points="25 0, 170 100, 25 100"/>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.triangle /></span>
                                    </b-button>
                                </div>
                                
                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'rectangleroundedcorner'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>   
                                                <rect fill="url(#img2)" x="25" y="0" width="150" height="100" rx="25" ry="25"></rect>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.rectangleroundedcorner /></span>
                                    </b-button>
                                </div>

                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'cross'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>   
                                                <polygon fill="url(#img2)" points="25 25, 80 25, 80 0, 120 0, 120 25, 175 25, 175 70, 120 70, 120 100, 80 100, 80 70, 25 70"></polygon>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.cross /></span>
                                    </b-button>
                                </div>

                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'text'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>    
                                                <text fill="url(#img2)" font-size="90" x="50" y="80">Aa</text>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.text /></span>
                                    </b-button>
                                </div>

                                <div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'ellipse'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>   
                                                <ellipse fill="url(#img2)" cx="100" cy="50" rx="75" ry="50"></ellipse>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.ellipse /></span>
                                    </b-button>
                                </div>

								<div class="col-4 pl-0 pr-2">
                                    <b-button variant="link" class="shape rounded-10 p-0 rounded-10 text-decoration-none mt-2 animated w-100 animated fadeIn" @click="selectedShape = 'beveledcorner'; step = 'isShowingDimensions'; setFocus('a');" name="btn">
                                        <div class="img-container d-flex align-items-center">
                                            <svg height="100" viewBox="-3 -3 206 106" stroke="#6c757d" stroke-width="4" xmlns="http://www.w3.org/2000/svg" class="texture d-block mx-auto my-4">
                                                <defs>
                                                    <pattern id="img2" patternUnits="userSpaceOnUse" width="300" height="200">
                                                        <image :href="'/modules/johnsteel_editeur/views/img/textures/' + selectedProduct + '-300.jpg'" x="0" y="0" width="300" height="200" />
                                                    </pattern>
                                                </defs>   
                                                <polygon fill="url(#img2)" points="25 25, 70 0, 130 0, 175 25, 175 70, 175 75, 130 100, 70 100, 25 75"></polygon>
                                            </svg>
                                        </div>
                                        <span class="h6 font-weight-bold text-white text-center rounded-bottom-10 d-block mb-0 bg-gris pt-2 pb-1 pb-sm-2 px-0"><t tunnelPopup.beveledcorner /></span>
                                    </b-button>
                                </div>
 
                                <div class="col-4 pl-0 pr-2 d-flex align-items-center justify-content-center flex-column cursor-pointer" @click="changeShapeStep(2, 1)" style="min-height: 200px">
                                    <span class="h1">...</span>
                                    <span class="d-block"><t tunnelPopup.otherShapes /></span>
                                </div>
 
                                <div class="col-4 pl-0 pr-2 d-flex align-items-center justify-content-center flex-column cursor-pointer" @click="changeShapeStep(2, 1)" style="min-height: 200px">
                                    <span class="h1">...</span>
                                    <span class="d-block"><t tunnelPopup.otherShapes /></span>
                                </div>
                            </div>
                        </div> 
                    </div>

                    <div id="dimensions" class="h-100 d-flex flex-wrap" v-if="step === 'isShowingDimensions'">
                        <b-button class="position-absolute return p-0 border-0 animated fadeIn texture" variant="link" @click="step = 'isShowingShapes'">
                            <svg data-v-4f717519="" viewBox="-.5 -.5 17 17" width="1em" height="1em" focusable="false" role="img" aria-label="arrow left circle fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-arrow-left-circle-fill rounded float-right b-icon bi" style="font-size: 200%;">
                                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"></path>
                            </svg>
                        </b-button>

                        <div class="d-flex align-items-end w-100 mx-auto pr-2">
                            <!-- <span class="font-weight-bold mb-0 pl-3 pr-2 d-block">
                                <t tunnelPopup.dimensions />
                                <b-icon v-if="!cuttingOptions.allowMaterialRotation" class="cursor-pointer icon-jaune" icon="info-circle-fill" font-scale=".9" @click="sense = !sense" />
                            </span> -->
                            <b-form v-on:submit.prevent class="w-100 animated fadeIn h-100 d-flex flex-column justify-content-center" autocomplete="false">
                                <div class="d-flex align-items-center flex-wrap mx-auto w-100 h-100 py-2">
                                    <div class="bg-gris-pro pt-4 pb-5 px-3 rounded-left-10 h-md-100 col-12 col-md-4 d-flex align-items-center">
                                        <div class="position-relative mx-auto">
                                            <svg width="95%" id="svg-container-form" class="texture d-block mx-auto" stroke="#6c757d" stroke-width="4" viewBox="-3 -3 206 106" xmlns="http://www.w3.org/2000/svg">
                                                <rect v-if="selectedShape == 'rectangle' || selectedShape == 'rectanglecutrectangle' || selectedShape == 'rectanglecutcircle' || selectedShape == 'holesrectangle'" fill="url(#img1)" x="25" y="0" width="150" height="100" rx="0" ry="0"></rect>
                                                <circle v-if="selectedShape == 'circle' || selectedShape == 'ring'" cx="100" cy="50" r="50" fill="url(#img1)"></circle>
                                                <polygon v-if="selectedShape == 'triangle'" points="25 0, 170 100, 25 100" fill="url(#img1)"></polygon>
                                                <text v-if="selectedShape == 'text'" class="b" x="50" y="91" font-size="115" fill="url(#img1)">A</text>
                                                <polygon v-if="selectedShape == 'trapeze'" fill="url(#img1)" points="80 0, 120 0, 150 100, 50 100"></polygon>
                                                <polygon v-if="selectedShape == 'forme-l'" fill="url(#img1)" points="25 0, 110 0, 110 70, 175 70, 175 100, 25 100"></polygon>
                                                <polygon v-if="selectedShape == 'notchrectangle'" fill="url(#img1)" points="25 0, 80 0, 80 55, 120 55, 120 0, 175 0, 175 70, 175 100, 25 100"></polygon>
                                                <rect v-if="selectedShape == 'rectangleroundedcorner'" fill="url(#img1)" x="25" y="0" width="150" height="100" rx="25" ry="25"></rect>
												<polygon v-if="selectedShape == 'cross'" fill="url(#img1)" points="25 25, 80 25, 80 0, 120 0, 120 25, 175 25, 175 75, 120 75, 120 100, 80 100, 80 75, 25 75"></polygon>
                                                <polygon v-if="selectedShape == 'beveledcorner'" fill="url(#img1)" points="25 25, 70 0, 130 0, 175 25, 175 70, 175 75, 130 100, 70 100, 25 75"></polygon>
                                                <ellipse v-if="selectedShape == 'ellipse'" fill="url(#img1)" cx="100" cy="50" rx="75" ry="50"></ellipse>
                                                <g v-if="selectedShape == 'rectanglerounded'">
                                                    <circle fill="url(#img1)" cx="100" cy="50" r="50"></circle>
                                                    <rect fill="url(#img1)" x="50" y="50" width="100" height="50" rx="0" ry="0" stroke-dasharray="0,100,200"></rect>
                                                </g>
                                                
                                                <g v-if="selectedShape == 'rectanglecutrectangle'">
                                                    <rect class="fond" fill="#f3f3f3" x="80" y="20" width="40" height="60" rx="0" ry="0"></rect>
                                                </g>

                                                <g v-if="selectedShape == 'holesrectangle'">
                                                    <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="55" cy="30" r="10"></circle>
                                                    <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="55" cy="72" r="10"></circle>
                                                    <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="145" cy="72" r="10"></circle>
                                                    <circle xmlns="http://www.w3.org/2000/svg" class="fond" fill="#FFFFFF" cx="145" cy="30" r="10"></circle>
                                                </g>                                     

                                                <g v-if="selectedShape == 'rectanglecutcircle'">
                                                    <circle class="fond" fill="#f3f3f3" cx="100" cy="50" r="35"></circle>
                                                </g>

                                                <g v-if="selectedShape == 'ring'">
                                                    <circle class="fond" fill="#f3f3f3" cx="100" cy="50" r="35"></circle>
                                                </g>

                                                <defs>
                                                    <pattern id="img1" patternUnits="userSpaceOnUse" :width="width" :height="height">
                                                        <image :xlink:href="'/modules/johnsteel_editeur/views/img/textures/' + this.productPsid + '.jpg'" x="0" y="0" :width="width" :height="height" />
                                                    </pattern>
                                                </defs>
                                            </svg>

                                            <svg width="100%" id="svg-container" class="texture d-block mx-auto position-absolute" stroke="#6c757d" stroke-width="4" viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
                                                <g v-if="selectedShape == 'rectanglecutrectangle'">
                                                    <line class="c" x1="42%" y1="84%" x2="58%" y2="84%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="47%" y="74%" fill="#555" stroke-width="0">C</text>

                                                    <line class="d" x1="37%" y1="21%" x2="37%" y2="74%" stroke-width="3" stroke="#555"></line>
                                                    <text class="d" x="28%" y="53%" fill="#555" stroke-width="0">D</text>
                                                </g>

                                                <g v-if="selectedShape == 'notchrectangle'">
                                                    <line class="c" x1="42%" y1="60%" x2="58%" y2="60%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="47%" y="79%" fill="#555" stroke-width="0">C</text>

                                                    <line class="d" x1="37%" y1="5%" x2="37%" y2="52%" stroke-width="3" stroke="#555"></line>
                                                    <text class="d" x="28%" y="35%" fill="#555" stroke-width="0">D</text>
                                                </g>

                                                <g v-if="selectedShape == 'rectanglecutcircle'">
                                                    <line class="c" x1="35%" y1="50%" x2="65%" y2="50%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="47%" y="43%" fill="#555" stroke-width="0">C</text>
                                                </g>

                                                <g v-if="selectedShape == 'ring'">
                                                    <line class="b" x1="35%" y1="50%" x2="64%" y2="50%" stroke-width="3" stroke="#555"></line>
                                                    <text class="b" x="47%" y="43%" fill="#555" stroke-width="0">B</text>
                                                </g>

                                                <g v-if="selectedShape != 'circle' && selectedShape != 'ring' && selectedShape != 'text' && selectedShape != 'rectanglerounded' && selectedShape != 'trapeze'">
                                                    <line class="b" x1="10%" y1="5%" x2="10%" y2="95%" stroke-width="3" stroke="#555"></line>
                                                    <text class="b" x="2%" y="54%" fill="#555" stroke-width="0">B</text>
                                                </g>

                                                <g v-if="selectedShape == 'trapeze' || selectedShape == 'rectanglerounded'">
                                                    <line class="b" x1="22%" y1="5%" x2="22%" y2="95%" stroke-width="3" stroke="#555"></line>
                                                    <text class="b" x="14%" y="54%" fill="#555" stroke-width="0">B</text>
                                                </g>

                                                <g v-if="selectedShape == 'triangle'">
                                                    <image class="c" xlink:href="@/assets/img/angle.svg" x="100" y="20" width="20" height="20" />
                                                    <text class="c" x="115" y="25" fill="#555" stroke-width="0">C</text>
                                                </g>

                                                <g v-if="selectedShape == 'trapeze'">
                                                    <line class="c" x1="40%" y1="-5%" x2="59%" y2="-5%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="47%" y="-11%" fill="#555" stroke-width="0">C</text>
                                                </g>

                                                <g v-if="selectedShape == 'forme-l'">
                                                    <line class="c" x1="57%" y1="76%" x2="85%" y2="76%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="68%" y="63%" fill="#555" stroke-width="0">C</text>

                                                    <line class="d" x1="51%" y1="5%" x2="51%" y2="65%" stroke-width="3" stroke="#555"></line>
                                                    <text class="d" x="57%" y="40%" fill="#555" stroke-width="0">D</text>
                                                </g>

                                                <g v-if="selectedShape == 'text'">
                                                    <line class="a" x1="20%" y1="2%" x2="20%" y2="92%" stroke-width="3" stroke="#555"></line>
                                                    <text class="a" x="12%" y="52%" fill="#555" stroke-width="0">A</text>
                                                </g>

                                                <g v-if="selectedShape == 'holesrectangle'">
                                                    <line class="c" x1="25%" y1="44%" x2="33%" y2="44%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="36%" y="50%" fill="#555" stroke-width="0">C</text>
                                                    <line class="d" x1="77%" y1="31%" x2="85%" y2="31%" stroke-width="3" stroke="#555"></line>
                                                    <line class="d" x1="71%" y1="5%" x2="71%" y2="20%" stroke-width="3" stroke="#555"></line>
                                                    <text class="d" x="77%" y="20%" fill="#555" stroke-width="0">D</text>
                                                </g>

                                                <g v-if="selectedShape != 'text' && selectedShape != 'circle' && selectedShape != 'ring' && selectedShape != 'trapeze' && selectedShape != 'rectanglerounded'">
                                                    <line class="a selected" x1="15%" y1="105%" x2="85%" y2="105%" stroke-width="3" stroke="#555" fill="fff"></line>
                                                    <text class="a selected" x="47%" y="123%" fill="#555" stroke-width="0">A</text>
                                                </g>

                                                <g v-if="selectedShape == 'circle' || selectedShape == 'ring' || selectedShape == 'trapeze' || selectedShape == 'rectanglerounded'">
                                                    <line class="a" x1="26%" y1="105%" x2="74%" y2="105%" stroke-width="3" stroke="#555"></line>
                                                    <text class="a" x="47%" y="123%" fill="#555" stroke-width="0">A</text>
                                                </g>

                                                <g v-if="selectedShape == 'cross'">
                                                    <line class="c" x1="61%" y1="33%" x2="84%" y2="33%" stroke-width="3" stroke="#555"></line>
                                                    <text class="c" x="68%" y="51%" fill="#555" stroke-width="0">C</text>

                                                    <line class="d" x1="56%" y1="5%" x2="56%" y2="24%" stroke-width="3" stroke="#555"></line>
                                                    <text class="d" x="47%" y="20%" fill="#555" stroke-width="0">D</text>
                                                </g>
                                                
                                                <g v-if="selectedShape == 'rectangleroundedcorner'">
                                                    <line class="coin-arrondi c" x1="76%" y1="21%" x2="81%" y2="11%" stroke-width="3" stroke="#555"></line>
                                                    <text class="coin-arrondi c" x="78%" y="36%" fill="#555" stroke-width="0">C</text>
                                                </g>

                                                <g v-if="selectedShape == 'beveledcorner'">
                                                    <line class="longueur-biseau c" x1="66%" y1="-2%" x2="85%" y2="-2%" stroke-width="3" stroke="#555"></line>
                                                    <text class="longueur-biseau c" x="73%" y="-7%" fill="#555" stroke-width="0">C</text>
                                                    <line class="largeur-biseau d" x1="88%" y1="3%" x2="88%" y2="24%" stroke-width="3" stroke="#555"></line>
                                                    <text class="largeur-biseau d" x="91%" y="19%" fill="#555" stroke-width="0">D</text>
                                                </g>

                                                <defs>
                                                    <marker id="triangleend" markerWidth="12" markerHeight="12" markerUnits="userSpaceOnUse" orient="auto" refX="5" refY="5">
                                                        <path d="M0,0 l7,5 l-7,5 z" style="fill:#555;stroke-width:0;"></path>
                                                    </marker>
                                                    <marker id="trianglestart" markerWidth="12" markerHeight="12" markerUnits="userSpaceOnUse" orient="auto-start-reverse" refX="5" refY="5">
                                                        <path d="M0,0 l7,5 l-7,5 z" style="fill:#555;stroke-width:0;"></path>
                                                    </marker>
                                                    <marker id="triangleendfocus" markerWidth="12" markerHeight="12" markerUnits="userSpaceOnUse" orient="auto" refX="5" refY="5">
                                                        <path d="M0,0 l7,5 l-7,5 z" style="fill:#ffb400;stroke-width:0;"></path>
                                                    </marker>
                                                    <marker id="trianglestartfocus" markerWidth="12" markerHeight="12" markerUnits="userSpaceOnUse" orient="auto-start-reverse" refX="5" refY="5">
                                                        <path d="M0,0 l7,5 l-7,5 z" style="fill:#ffb400;stroke-width:0;"></path>
                                                    </marker>
                                                    <marker id="circle" markerWidth="12" markerHeight="12" markerUnits="userSpaceOnUse" orient="auto" refX="5" refY="5">
                                                        <circle style="fill:#555;fill-opacity:1;" cx="5" cy="5" r="3" stroke-width="0"></circle>
                                                    </marker>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                    
                                    <div id="input-dimension" class="pt-2 pb-1 pb-md-0 rounded-10 mt-2 mt-sm-0 col-12 col-md-8 px-0 border-gris-pro rounded-right-10 h-md-100">
                                        <!-- <div class="mb-2">
                                            <transition-group name="bounce" tag="div">
                                                <div class="fly-over-setting mt-2 position-relative mx-3" v-if="sense" key="tuto" @click="sense = null">
                                                    <div class="bg-white rounded-10 px-3 py-2 text-left d-flex">
                                                        <img id="arrow-sense" :src="require('@/assets/img/right-arrow.svg')">
                                                        <p class="text-dark mb-0 line-height ml-2"><t tunnelPopup.tutoSense /></p>
                                                    </div>
                                                </div>
                                            </transition-group>
                                        </div> -->

                                        <div class="d-flex mb-2 flex-column justify-content-between h-100">
                                            <div class="mt-2">
                                                <div v-if="selectedShape != 'circle' && selectedShape != 'ring'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-a" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">A</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="a" ref="a" v-model="form.a" type="number" name="dimensions[a]" :min="cuttingOptions.minimalWidth" :max="cuttingOptions.maximalWidth" @focus="onFocus('a')" @blur="unFocus()" @input="onChange()" placeholder="1000" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.a">{{form.a}}</span>
                                                                <span v-else>1000</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{cuttingOptions.minimalWidth}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">{{cuttingOptions.maximalWidth}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>

                                                <div v-else class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-a" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">A</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="a" v-model="form.a" type="number" name="dimensions[a]" :min="cuttingOptions.minimalWidth" :max="cuttingOptions.maximalHeight" @focus="onFocus('a')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.a">{{form.a}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{cuttingOptions.minimalWidth}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">{{cuttingOptions.maximalHeight}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>

                                                <div v-if="selectedShape != 'text' && selectedShape != 'circle' && selectedShape != 'ring'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-b" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">B</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="b" v-model="form.b" type="number" name="dimensions[b]" :min="cuttingOptions.minimalHeight" :max="cuttingOptions.maximalHeight" @focus="onFocus('b')" @blur="unFocus()" @input="onChange()" placeholder="1000" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.b">{{form.b}}</span>
                                                                <span v-else>1000</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.b }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{cuttingOptions.minimalHeight}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">{{cuttingOptions.maximalHeight}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>

                                                <div v-if="selectedShape == 'ring' " class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-b" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">B</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="b" v-model="form.b" type="number" name="dimensions[b]" :min="cuttingOptions.drillingThresholdDiameter" :max="maxInsideWidth" @focus="onFocus('b')" @blur="unFocus()" @input="onChange()" placeholder="1000" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.b">{{form.b}}</span>
                                                                <span v-else>1000</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.b }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="form.a"  class="font-weight-bold">{{Math.floor(form.a - cuttingOptions.internalPadding)}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalHeight - cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>

                                                <div v-if="selectedShape == 'text'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-b" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">B</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="b" v-model="form.b" type="text" name="dimensions[b]" @focus="onFocus('b')" @blur="unFocus()" @input="onChange()" placeholder="Texte" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span><t tunnelPopup.text /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="selectedShape == 'triangle'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-c" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">C</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="c" v-model="form.c" type="number" name="dimensions[c]" :min="0" :max="90" @focus="onFocus('c')" @blur="unFocus()" @input="onChange()" placeholder="90" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.c">{{form.c}}</span>
                                                                <span v-else>90</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.c }]"> °</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">0</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">90</span>
                                                        °
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'rectanglecutrectangle' || selectedShape == 'trapeze' || selectedShape == 'forme-l' || selectedShape == 'notchrectangle'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-c" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">C</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="c" v-model="form.c" type="number" name="dimensions[c]" :min="cuttingOptions.thickness - 1" :max="maxInsideWidth" @focus="onFocus('c')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.c">{{form.c}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="selectedShape == 'rectanglerounded' && maxInsideWidth"  class="font-weight-bold">{{maxInsideWidth}}</span>
                                                        <span v-else-if="form.a"  class="font-weight-bold">{{Math.floor(form.a - cuttingOptions.internalPadding)}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalWidth - cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
												<div v-if="selectedShape == 'cross' || selectedShape == 'beveledcorner'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-c" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">C</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="c" v-model="form.c" type="number" name="dimensions[c]" :min="cuttingOptions.thickness - 1" :max="maxInsideWidth/2" @focus="onFocus('c')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.c">{{form.c}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="form.a"  class="font-weight-bold">{{Math.floor(form.a/2 - cuttingOptions.internalPadding)}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalWidth/2 - cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'rectanglecutcircle' || selectedShape == 'rectangleroundedcorner'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-c" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">C</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="c" v-model="form.c" type="number" name="dimensions[c]" :min="cuttingOptions.thickness - 1" :max="maxInsideBoth/2" @focus="onFocus('c')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.c">{{form.c}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="maxInsideBoth"  class="font-weight-bold">{{Math.floor(maxInsideBoth - cuttingOptions.internalPadding)/2}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalWidth - cuttingOptions.internalPadding)/2}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'rectanglecutrectangle' || selectedShape == 'forme-l' || selectedShape == 'notchrectangle'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-d" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">D</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="d" v-model="form.d" type="number" name="dimensions[d]" :min="cuttingOptions.thickness - 1" :max="maxInsideHeight" @focus="onFocus('d')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.d">{{form.d}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="form.b"  class="font-weight-bold">{{Math.floor(form.b - cuttingOptions.internalPadding)}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalHeight - cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'cross' || selectedShape == 'beveledcorner'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-d" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">D</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="d" v-model="form.d" type="number" name="dimensions[d]" :min="cuttingOptions.thickness - 1" :max="maxInsideHeight/2" @focus="onFocus('d')" @blur="unFocus()" @input="onChange()" placeholder="500" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.d">{{form.d}}</span>
                                                                <span v-else>500</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.a }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span v-if="form.b"  class="font-weight-bold">{{Math.floor(form.b/2 - cuttingOptions.internalPadding)}}</span>
                                                        <span v-else class="font-weight-bold">{{Math.floor(cuttingOptions.maximalHeight/2 - cuttingOptions.internalPadding)}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'holesrectangle'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-c" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold">C</span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="c" ref="c" v-model="form.c" type="number" name="dimensions[c]" :min="cuttingOptions.thickness" :max="getMaxForHolesRectangleInput('radiusHoles')" @focus="onFocus('c')" @blur="unFocus()" @input="onChange()" placeholder="1000" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.c">{{form.c}}</span>
                                                                <span v-else>1000</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.c }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.thickness)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">{{getMaxForHolesRectangleInput('radiusHoles')}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                                <div v-if="selectedShape == 'holesrectangle'" class="col-12">
                                                    <div class="d-flex border-gris-pro rounded-10">
                                                        <span id="input-d" class="input-group-text border-0 py-1 bg-gris-pro empty">
                                                            <span class="empty-step animated font-weight-bold"></span>
                                                            <img class="checked-step animated" width="17" src="@/assets/img/checked-step.svg">
                                                            <img class="not-checked-step animated" width="18" src="@/assets/img/not-checked.svg">
                                                        </span>
                                                        <div class="input-number position-relative w-100">
                                                            <b-form-input id="d" ref="d" v-model="form.d" type="number" name="dimensions[d]" :min="cuttingOptions.thickness" :max="getMaxForHolesRectangleInput('distanceBorders')" @focus="onFocus('d')" @blur="unFocus()" @input="onChange()" placeholder="1000" autocomplete="off" required v-on:keyup.enter="readyForCreateShape()" class="border-0 rounded-right-10" />
                                                            <span class="suffix-detail d-flex align-items-center">
                                                                <span v-if="form.d">{{form.d}}</span>
                                                                <span v-else>1000</span>
                                                                <span class="suffix" :class="[{'opa-5' : !form.d }]"> <t tunnelPopup.mm /></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="limit">
                                                        <t class="small" tunnelPopup.entre />
                                                        <span class="font-weight-bold">{{Math.ceil(cuttingOptions.thickness)}}</span>
                                                        <t class="small" tunnelPopup.et />
                                                        <span class="font-weight-bold">{{getMaxForHolesRectangleInput('distanceBorders')}}</span>
                                                        <t class="small" tunnelPopup.mm />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-end my-2 my-md-3 ml-0 mr-2 ml-md-3 mr-md-3">
                                                <b-button class="btn-vert p-0 responsive-btn" @click="createShape(selectedShape)" :disabled="!this.canCreate">
                                                    <span><t tunnelPopup.createPiece /></span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </b-container>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
    import { BModal, BButton, VBModal, BIcon, BIconArrowLeftCircleFill, BContainer, BForm, BFormGroup, BCard, BFormCheckboxGroup, BFormSelect, BFormCheckbox, BFormInput, BRow, BCol} from 'bootstrap-vue'
    import { mapGetters } from 'vuex'
    import { models } from 'feathers-vuex';
    import vSelect from 'vue-select'
    import { MaterialRectangle } from '../../shapes/toolshapes/MaterialRectangle';
    import { MaterialTriangle } from '../../shapes/toolshapes/MaterialTriangle';
    import { MaterialText } from '../../shapes/toolshapes/MaterialText';
    import { MaterialCircle } from '../../shapes/toolshapes/MaterialCircle';
    import { MaterialSvg } from '../../shapes/toolshapes/MaterialSvg';
    import { CutRectangle } from '../../shapes/toolshapes/CutRectangle';
    import { CutCircle } from '../../shapes/toolshapes/CutCircle';
    import { CutTriangle} from '../../shapes/toolshapes/CutTriangle';
    import ToolsUtils from '@/services/ToolsUtils'
    import PathUtils from '../../services/PathUtils';

    export default {
        components: {BModal, BButton, VBModal, vSelect, BIcon, BIconArrowLeftCircleFill, BContainer, BForm, BFormGroup, BCard, BFormCheckboxGroup, BFormSelect, BFormCheckbox, BFormInput, BRow, BCol},
        directives: {'b-modal': VBModal},
        data(){
            return {
                step: window.obelix.tunnelStep,
                products: [],
                cuttingparams: [],
                categories:[],
                selectedMaterial: null,
                selectedMatter: null,
                selectedProduct: null,
                selectedThickness: null,
                selectedShape: null,
                canCreate: false,
                allowMaterialRotation: 0,
                tunnel: window.obelix.tunnel,
                sense: null,
                form: {
                    a: 0,
                    b: 0,
                    c: 0,
                    d: 0
                },
                width: 0,
                height: 0,
                language: window.obelix.language,
                timer: 0
            }
        },
        async mounted() {
            await this.refreshProducts();
            await this.refreshThicknesses();
            await this.refreshCuttingParams();
            await this.refreshCategories();
            await this.refreshMatters();
            this.$nextTick(() => {
                this.dataLoaded = true
            });
            let category = this.productPsid;
            var img = new Image();
            img.src = '/modules/johnsteel_editeur/views/img/textures/'+ category +'.jpg';
            img.onload = ()=>{
                this.width = img.width;
                this.height = img.height;   
            };
        },
        computed: {
            ...mapGetters([
                'tool',
                'cuttingOptions',
                'productPsid'
            ]),
            thicknessesForProduct: function() {
                let thicknessIds = this.cuttingparams
                    .filter(p => p.product == this.selectedProduct)
                    .map(p => p.thickness);

                return this.thicknesses.filter(t => thicknessIds.includes(t.psid) );
            },
            mattersForProduct() {
                return this.matters.filter(matter => {
                    return matter.category_id == this.selectedMaterial.category_id;
                });
            },
            shadesForProduct() {
                return this.products.filter(product => {
                    return product.matter_id == this.selectedMatter.matter_id && !product.steelgoods;
                });
            },
            maxInsideWidth() {
                let max;
                switch (this.selectedShape) {
                    case 'rectanglerounded':
                        if(this.form.a || this.form.b) max = (this.form.a <= this.form.b) ? this.form.a : this.form.b;
                        else max = this.cuttingOptions.maximalWidth - this.cuttingOptions.internalPadding;
                        break;

                    case 'ring':
                        if(this.form.a) max = this.form.a - this.cuttingOptions.internalPadding;
                        else max = this.cuttingOptions.maximalHeight - this.cuttingOptions.internalPadding;
                        break;
                
                    default:
                        if(this.form.a) max = this.form.a - this.cuttingOptions.internalPadding;
                        else max = this.cuttingOptions.maximalWidth - this.cuttingOptions.internalPadding;
                        break;
                }
                return max; 
            },

            maxInsideHeight() {
                let max;
                if(this.form.b) max = this.form.b - this.cuttingOptions.internalPadding;
                else max = this.cuttingOptions.maximalHeight - this.cuttingOptions.internalPadding;
                return max; 
            },

            maxInsideBoth() {
                let max;
                var maxa = 0;
                var maxb = 0;

                if(this.form.a) maxa = this.form.a - this.cuttingOptions.internalPadding;
                else maxa = this.cuttingOptions.maximalWidth - this.cuttingOptions.internalPadding;

                if(this.form.b) maxb = this.form.b - this.cuttingOptions.internalPadding;
                else maxb = this.cuttingOptions.maximalHeight - this.cuttingOptions.internalPadding;

                if(maxa > maxb) max = maxb;
                else max = maxa;
                
                return max; 
            },
        },
        methods: {
            getMaxForHolesRectangleInput(params){
                let valA;
                let valB;
                let lowest_value;

                if(this.form.a){
                    valA = parseInt(this.form.a);
                }else{
                    valA = parseInt(this.cuttingOptions.maximalWidth);
                }
                if(this.form.b){
                    valB = parseInt(this.form.b);
                }else{
                    valB = parseInt(this.cuttingOptions.maximalHeight);
                }
                if(valA > valB){
                    lowest_value = valB - this.cuttingOptions.thickness;
                }else{
                    lowest_value = valA - this.cuttingOptions.thickness;
                }
                if(params == "radiusHoles"){
                    return Math.ceil((lowest_value)/2 - this.cuttingOptions.thickness);
                }else if(params == 'distanceBorders'){
                    return Math.ceil((lowest_value)/2 - this.form.c);
                }
            },
            async refreshProducts() {
                let blockSize = 20;
                let response = await models.api.Product.find({query: {$limit: blockSize}});
                this.products = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.products = this.products.concat(response.data);
                }
                this.products.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            },
            async refreshThicknesses() {
                let blockSize = 50;
                let response = await models.api.Thickness.find({query: {$limit: blockSize}});
                this.thicknesses = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.thicknesses = this.thicknesses.concat(response.data);
                }
                this.thicknesses.sort((a, b) => a.thickness - b.thickness);
                this.thicknesses.forEach(t => t.name = t.thickness + ' mm');
            },
            async refreshCuttingParams() {
                let blockSize = 20;
                let response = await models.api.CuttingParams.find({query: {$limit: blockSize}});
                this.cuttingparams = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.CuttingParams.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.cuttingparams = this.cuttingparams.concat(response.data);
                }

                let activeProducts = new Set(this.cuttingparams
                    .filter(cp => cp.cuttingOptions.active == 1)
                    .map(cp => cp.product));

                this.products = this.products.filter(p => activeProducts.has(p.psid));
            },

            async refreshCategories() {
                let blockSize = 20;
                let response = await models.api.Category.find({query: {$limit: blockSize}});
                this.categories = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Category.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.categories = this.categories.concat(response.data);
                }
                this.categories.sort((a, b) => a.category_id - b.category_id);
            },

            async refreshMatters() {
                let blockSize = 20;
                let response = await models.api.Matter.find({query: {$limit: blockSize}});
                this.matters = response.data;
                let steps = response.total / blockSize;

                for (let i = 1; i < steps; i++) {
                    response = await models.api.Matter.find({query: {$limit: blockSize, $skip: i * blockSize}});
                    this.matters = this.matters.concat(response.data);
                }
                this.matters.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            },
            hideModal() {
                this.$refs['modal-1'].hide();
            },
            getUrlName(name) {
                var accent = [
                    /[\300-\306]/g, /[\340-\346]/g, // A, a
                    /[\310-\313]/g, /[\350-\353]/g, // E, e
                    /[\314-\317]/g, /[\354-\357]/g, // I, i
                    /[\322-\330]/g, /[\362-\370]/g, // O, o
                    /[\331-\334]/g, /[\371-\374]/g, // U, u
                    /[\321]/g, /[\361]/g, // N, n
                    /[\307]/g, /[\347]/g, // C, c
                ];
                var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

                for(var i = 0; i < accent.length; i++){
                    name = name.replace(accent[i], noaccent[i]);
                }
                return name.replace(' ', '-').toLowerCase();
            },
            readyForCreateShape(){
                if(this.canCreate){
                    this.createShape(this.selectedShape);
                }
            },
            createShape(selectedShape){
                let shapes;
                let shape;
                if (typeof gtag != 'undefined'){
                    gtag('event', 'select_shape', {
                        'shape_name' : selectedShape
                    });
                }
                if (selectedShape == "rectangle") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    shape = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    shapes = [shape];

                } else if(selectedShape == "circle") {
                    shape = new MaterialCircle({ x: parseFloat(this.form.a /2), y: -parseFloat(this.form.a /2) }, parseFloat(this.form.a/2));
                    shapes = [shape];

                } else if(selectedShape == "triangle") {
                    let summit = (Math.cos(parseInt(this.form.c)*Math.PI/180) * parseInt(this.form.b)) / parseInt(this.form.b);
                    let heightTriangle = Math.sin(parseInt(this.form.c)*Math.PI/180) * parseInt(this.form.b);
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -heightTriangle });
                    shape = new MaterialTriangle(
                        boundingRectangle, summit
                    );
                    shapes = [shape];

                } else if(selectedShape == "text") {
                    let width = this.form.b.length * (parseInt(this.form.a) * 1.3);
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: width, y: -parseInt(this.form.a) });
                    shape = new MaterialText(
                            boundingRectangle, 'ubuntu', this.form.b
                    );
                    shapes = [shape];

                }else if(selectedShape == "rectanglecutrectangle") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let insideRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    insideRectangle.center = boundingRectangle.center;
                    let out = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    let internal = new CutRectangle(
                        insideRectangle, 0
                    );
                    shapes = [out,internal];

                }else if(selectedShape == "rectanglecutcircle") {
                    
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    
                    let out = new MaterialRectangle(
                        boundingRectangle, 0
                    );

                    let internal = new CutCircle(boundingRectangle.center, parseInt(this.form.c)/2);

                    shapes = [out,internal];
                }else if(selectedShape == "rectanglerounded") {
                    let angle = parseInt(this.form.a) > parseInt(this.form.b) ? parseInt(this.form.b)/2 : parseInt(this.form.a)/2;
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let roundCorner = {"topLeft" : angle, "topRight" : angle,  "bottomLeft" : 0, "bottomRight" : 0};
                    shape = new MaterialRectangle(
                        boundingRectangle, 0, roundCorner
                    );

                    shapes = [shape];
                }else if(selectedShape == "ring") {
                    
                    shape = new MaterialCircle({ x: parseInt(this.form.a), y: -parseInt(this.form.a) }, parseInt(this.form.a)/2);
                    let internal = new CutCircle(shape.center, parseInt(this.form.b)/2);

                    shapes = [shape,internal];
                }
                else if(selectedShape == "trapeze") {
                    
                    let triangleWidth  = (parseInt(this.form.a)-parseInt(this.form.c))/2;
                    let rectangleWidth = parseInt(this.form.c)
                    let summit = (Math.cos(parseInt(90)*Math.PI/180) * parseInt(this.form.b)) / parseInt(this.form.b);
                    let heightTriangle = Math.sin(parseInt(90)*Math.PI/180) * parseInt(this.form.b);
                    let firstBoundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: triangleWidth, y: -heightTriangle });
                    let secondBoundingRectangle = ToolsUtils.boundingRectangle({ x: triangleWidth, y: 0 }, { x: triangleWidth + rectangleWidth, y: -parseInt(this.form.b) });
                    let lastBoundingRectangle = ToolsUtils.boundingRectangle({ x: rectangleWidth + triangleWidth, y: 0 }, { x:  rectangleWidth + (triangleWidth*2), y:-heightTriangle });

                    let leftTriangle = new MaterialTriangle(
                        firstBoundingRectangle, summit
                    );

                    let rectangle = new MaterialRectangle(
                        secondBoundingRectangle, 0
                    );
                    let rightTriangle = new MaterialTriangle(
                        lastBoundingRectangle, summit
                    );

                    leftTriangle.heightPos = 1;
                    rightTriangle.heightPos = 0;
                    shapes = [leftTriangle,rectangle,rightTriangle];
                }else if(selectedShape == "forme-l") {
                    let firstRectangleDimensions = { x: parseInt(this.form.a)-parseInt(this.form.c), y: -parseInt(this.form.b) };
                    let secondRectangleDimensions = { x: parseInt(this.form.a), y: -parseInt(this.form.b)+parseInt(this.form.d) };
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, firstRectangleDimensions);
                    let secondBoundingRectangle = ToolsUtils.boundingRectangle({ x: firstRectangleDimensions.x, y: 0 },secondRectangleDimensions);
                    let firstRectangle = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    let secondRectangle = new MaterialRectangle(
                        secondBoundingRectangle, 0
                    );
                    shapes = [firstRectangle,secondRectangle];
                }else if(selectedShape == "notchrectangle") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let insideRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0}, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });

                    let out = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    let internal = new CutRectangle(
                        insideRectangle, 0
                    );
                    internal.move({x:parseInt(this.form.a / 2) - (parseInt(this.form.c / 2)), y: -(parseInt(this.form.b) - parseInt(this.form.d))});
                    shapes = [out,internal];
                }else if(selectedShape == "holesrectangle") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    
                    let rectangle = new MaterialRectangle(
                        boundingRectangle, 0
                    );

                    let radius = parseInt(this.form.c / 2);
                    let distance = parseInt(this.form.d);
                    let circle_bottom_left = new CutCircle({x:0, y:0}, radius);
                    let circle_bottom_right = new CutCircle({x:0, y:0}, radius);
                    let circle_top_left = new CutCircle({x:0, y:0}, radius);
                    let circle_top_right = new CutCircle({x:0, y:0}, radius);

                    circle_bottom_left.move({x:(distance + radius), y: -(distance + radius)});
                    circle_bottom_right.move({x:parseInt(this.form.a) - (distance + radius), y: -(distance + radius)});
                    circle_top_left.move({x:(distance + radius), y: -(parseInt(this.form.b) - (distance + radius))});
                    circle_top_right.move({x:parseInt(this.form.a) - (distance + radius), y: -(parseInt(this.form.b) - (distance + radius))});

                    shapes = [rectangle,circle_bottom_left, circle_bottom_right, circle_top_left, circle_top_right];
                }
                else if(selectedShape == "rectangleroundedcorner") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let radius = parseInt(this.form.c);
                    let rectangle = new MaterialRectangle(
                        boundingRectangle, {'width': radius, "height": radius}
                    )
                    shapes = [rectangle]

                }else if(selectedShape == "cross") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let bottomLeftCut  = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let topLeftCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let bottomRightCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let topRightCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    topLeftCut.topLeft = boundingRectangle.topLeft;
                    bottomRightCut.bottomRight = boundingRectangle.bottomRight;
                    topRightCut.topRight = boundingRectangle.topRight;
                    let out = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    let bottomLeftCorner = new CutRectangle(
                        bottomLeftCut, 0
                    );
                    let TopLeftCorner = new CutRectangle(
                        topLeftCut, 0
                    );
                    let bottomRightCorner = new CutRectangle(
                        bottomRightCut, 0
                    );
                    let topRightCorner = new CutRectangle(
                        topRightCut, 0
                    ); 
					shapes = [out,bottomLeftCorner,TopLeftCorner,bottomRightCorner,topRightCorner];
                }else if(selectedShape == "ellipse") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let ellipse = new MaterialSvg(
                        boundingRectangle,
                        'M 11 6 Z Z A 1 1 0 0 0 13 8 A 1 1 0 0 0 11 6 Z',
                        'ellipse'
                        )
                    ellipse.keepProportions = false;
                    shapes = [ellipse]

                }else if(selectedShape == "beveledcorner") {
                    let boundingRectangle = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.a), y: -parseInt(this.form.b) });
                    let bottomLeftCut  = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let topLeftCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let bottomRightCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    let topRightCut = ToolsUtils.boundingRectangle({ x: 0, y: 0 }, { x: parseInt(this.form.c), y: -parseInt(this.form.d) });
                    topLeftCut.topLeft = boundingRectangle.topLeft;
                    bottomRightCut.bottomRight = boundingRectangle.bottomRight;
                    topRightCut.topRight = boundingRectangle.topRight;
                    let out = new MaterialRectangle(
                        boundingRectangle, 0
                    );
                    let bottomLeftCorner = new CutTriangle(
                        bottomLeftCut, 0
                    );
                    let TopLeftCorner = new CutTriangle(
                        topLeftCut, 1
                    );
                    let bottomRightCorner = new CutTriangle(
                        bottomRightCut, 1
                    );
                    let topRightCorner = new CutTriangle(
                        topRightCut, 0
                    ); 
                    TopLeftCorner.rotation = 180;
                    topRightCorner.rotation = 180;
					shapes = [out,bottomLeftCorner,TopLeftCorner,bottomRightCorner,topRightCorner];
                }
                shapes.forEach(element => {
                    element.updatePath();
                });
                this.$store.dispatch('addShapes', shapes);
                this.$store.dispatch('setSelectedShapes', shapes);
                this.$store.dispatch('setDropped', 'cart');
                PathUtils.autoZoomOn(shapes);
                this.hideModal();

                if (document.querySelector('#menu-mobile') != null) {
                    var target = document.querySelector('#menu-mobile').offsetTop;
                    setTimeout(function() {
                        window.scroll({top: target, left: 0, behavior: 'smooth'});
                    }, 2000);
                }
                
            },
            async onFocus(letter){
                document.querySelectorAll('#svg-container .' + letter).forEach(e => {
                    e.classList.add('selected');
                });
            },
            async unFocus(){
                document.querySelectorAll('#svg-container *').forEach(e => {
                    e.classList.remove('selected');
                });
            },
            async setFocus(letter) {
                this.timer = setTimeout( () =>  {
                    document.querySelector('#' + letter).focus();
                }, 200);
            },
            async onChange(){
                clearTimeout(this.timer);
                var validForm = true;

                this.timer = setTimeout( () =>  {
                    document.querySelectorAll('#input-dimension input').forEach( el => {
                        var id = el.getAttribute('id');
                        if(el.getAttribute('type') == 'text'){
                            if(el.value){
                                document.querySelector('#input-' + id).classList.remove('empty');
                                document.querySelector('#input-' + id).classList.remove('not-good');
                                document.querySelector('#input-' + id).classList.add('good');
                            }else{
                                document.querySelector('#input-' + id).classList.remove('good');
                                document.querySelector('#input-' + id).classList.add('empty');
                            }
                            return;
                        }
                        var value = parseInt(el.value);
                        var min = parseInt(el.getAttribute('min'));
                        var max = parseInt(el.getAttribute('max'));

                        if (value) {
                            if (value < min || value > max) {
                                document.querySelector('#input-' + id).classList.remove('empty');
                                document.querySelector('#input-' + id).classList.remove('good');
                                document.querySelector('#input-' + id).classList.add('not-good');
                            } else {
                                document.querySelector('#input-' + id).classList.remove('empty');
                                document.querySelector('#input-' + id).classList.remove('not-good');
                                document.querySelector('#input-' + id).classList.add('good');
                            }
                        }
                    });

                    document.querySelectorAll('.input-group-text').forEach( el => {
                        if (el.classList.contains('empty') || el.classList.contains('not-good')) {
                            validForm = false;
                        }
                    });

                    if (validForm) {
                        document.querySelector('.btn.btn-vert').classList.remove('disabled');
                        document.querySelector('.btn.btn-vert').disabled = false;
                    } else {
                        document.querySelector('.btn.btn-vert').classList.add('disabled');
                        document.querySelector('.btn.btn-vert').disabled = true;
                    }
                }, 500);
            },
            changeShapeStep(current, next) {
                if (current < next) {
                    document.querySelector('#block-shape_' + next).classList.add('fadeInRight', 'd-flex');
                    document.querySelector('#block-shape_' + next).classList.remove('d-none', 'fadeOutLeft', 'fadeOutRight');

                    document.querySelector('#block-shape_' + current).classList.add('fadeOutLeft');
                    document.querySelector('#block-shape_' + current).classList.remove('fadeInRight', 'fadeInRight');
                } else {
                    document.querySelector('#block-shape_' + next).classList.add('fadeInLeft', 'd-flex');
                    document.querySelector('#block-shape_' + next).classList.remove('d-none', 'fadeOutLeft', 'fadeOutRight');

                    document.querySelector('#block-shape_' + current).classList.add('fadeOutRight');
                    document.querySelector('#block-shape_' + current).classList.remove('fadeInRight', 'fadeInRight');
                }
            }
        },
        watch: {
            selectedMaterial: async function() {
                this.$store.dispatch('setMaterialName', this.selectedMaterial.name['fr']);
            },
            selectedMatter: async function() {
                this.$store.dispatch('setMatterName', this.selectedMatter.name[this.language]);
            },
            selectedProduct: async function() {
                if (this.thicknessesForProduct.length < 1) return;
                if (this.thicknessesForProduct.some(t => t.psid == this.selectedThickness)) {
                    if (this.dataLoaded) {
                        this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
                    }
                }
                else
                {
                    if (this.dataLoaded) {
                        this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.thicknessesForProduct[0].psid});
                    }
                }

                let category = this.selectedProduct;
                var img = new Image();
                img.src = '/modules/johnsteel_editeur/views/img/textures/'+ category +'.jpg';
                img.onload = ()=>{
                    this.width = img.width;
                    this.height = img.height;   
                };
            },
            selectedThickness: async function() {
                this.$store.dispatch('setArticle', {product: this.selectedProduct, thickness: this.selectedThickness});
            },
            selectedShape: async function(n, o) {
                this.form.a = '';
                this.form.b = '';
                this.form.c = '';
                this.form.d = '';
            },

            cuttingOptions: function() {
                if (this.cuttingOptions) {
                    if (this.cuttingOptions.allowMaterialRotation) {
                        this.allowMaterialRotation = true;
                    }
                }
            }
        },
    }
</script>


<style lang="scss">
    #modal-1 {
        #matters {
            .btn {
                background-size: 300px;

                span {
                    text-shadow: 0 1px 3px black;
                }
            }
        }
        #input-dimension {
            .checked-step {
                display: none;
            }
            .not-checked-step {
                display: none;
            }
        }
        #dimensions{
            justify-content: center;

            .col {
                padding: 0;
            }

            input::placeholder {
                opacity: .5;
            }

            input:disabled {
                cursor: not-allowed;
            }

            .rounded-left-10 {
                @media (max-width: 767px) {
                    border-radius: 10px 10px 0 0!important;
                }
            }
        }
        #shapes {
            .shape svg {
                @media (max-width: 767px) {
                    height: 80px!important;
                }
            }
        }
        button {
            background-size: cover;
        }
        .h1 {
            @media (max-width: 1199px) {
                font-size: 1.75rem;
            }
            @media (max-width: 990px) {
                font-size: 1.5rem;
            }
        }
        .h4 {
            @media (max-width: 1199px) {
                font-size: 1.25rem;
            }
            @media (max-width: 990px) {
                font-size: 1rem;
            }
        }
        .h5 {
            @media (max-width: 990px) {
                font-size: 1rem;
            }
        }
        .h6 {
            @media (max-width: 767px) {
                font-size: .8rem;
            }
        }
        .rounded-right-10 {
            @media (max-width: 990px) {
                border-radius: 0 0 10px 10px!important;
            }
        }
        .bg-rose.rounded-10 {
            @media (max-width: 576px) {
                border-radius: 10px 10px 0 0!important;
            }
        }
        .thickness {
            svg {
                @media (max-width: 1200px) {
                    height: 100%;
                    width: 100%;
                    margin: 15px 0 0 0!important;
                    padding: 0 1rem!important;
                }
            }
        }
        .responsive-btn {
            @media (max-width: 576px) {
                &.p-0 {
                    width: 100%;
                }
            }

            &.animated {
                span {
                    @media (max-width: 576px) {
                        font-size: 80%;
                    }
                }
            }
        }
        #shades {
            .btn {
                background-size: 300px;
                white-space: break-spaces;
            }

            span {
                text-shadow: 0 1px 3px black;
                @media (max-width: 990px) {
                    font-weight: bold;
                }
            }
        }
        .modal-dialog {
            @media (max-width: 577px) {
                margin: 0 1rem!important; 
            }
        }
        #svg-container {
            overflow: initial;
            height: 110px;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            margin: auto;
        }
        #svg-container-form {
            height: 110px;
        }
        line {
            marker-end:url(#triangleend);
            marker-start:url(#trianglestart);
        }
        .fly-over-setting:after {
            border-bottom: 15px solid white!important;
        }
        #arrow-sense {
            height: 25px;
        }
        .btn.disabled {
            opacity: .5;
            cursor: not-allowed;
        }
        .materials-img {
            overflow: hidden;
            position: relative;
            height: 100%;

            img {
                width: auto;
                height: auto;
                min-height: 100%;
                top: 0;
                left: 0;
                min-width: 100%; 
            }
        }

        .not-good {
            background: rgba(237,28,36,.6)!important;

            .empty-step,
            .checked-step {
                display: none!important;
            }

            .not-checked-step {
                display: block!important;
            }
        }

        .good {
            background: rgba(37,203,104,.6)!important;

            .empty-step, 
            .not-checked-step {
                display: none!important;
            }

            .checked-step {
                display: block!important;
            }
        }

        .input-group-text {
            border-radius: 7px 0 0 7px!important;
        }

        line.selected {
            stroke: #ffb400;
            marker-start: url('#trianglestartfocus');
            marker-end: url('#triangleendfocus');
        }
        text.selected {
            fill: #ffb400;
        }
    }
</style>
